// Runtime configuration resolved from Vite environment variables.
// No product logic lives here so this module can later be lifted into the
// shared WP-700 package set verbatim.

export const config = {
  /** Base URL of the Platform API v1 surface (env may override). */
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL ?? '/api/v1/platform').replace(/\/+$/, ''),

  /** Public origin of this Platform web app, used for launcher self-links. */
  platformOrigin: import.meta.env.VITE_PLATFORM_ORIGIN ?? window.location.origin,

  /** The Platform web app always operates on the PLATFORM product audience. */
  productCode: 'PLATFORM' as const,
};

/**
 * Preserve the development proxy prefix when resolving the root-level hub. Absolute URLs
 * (Media Server photos) are returned unchanged.
 */
export const platformHubUrl = (path: string) =>
  /^https?:\/\//i.test(path) ? path : `${config.apiBaseUrl.replace(/\/api\/v1\/platform$/, '')}${path}`;
